const state = {

    WebinarList          : [],
    WebinarRegistrations : []
}

const mutations = {
    SetWebinarList(state, payload) {

        state.WebinarList = payload

    },
    SetIndividualWebinar(state, payload) {

        state.WebinarList.push(payload)

    },
    UpdateIndividualWebinar(state, payload) {

        let index = state['WebinarList'].findIndex(x => x["_id"] == payload["_id"])
        state['WebinarList'].splice(index, 1, payload)

    },
    DeleteIndividualWebinar(state, payload) {

        let index = state['WebinarList'].findIndex(x => x["_id"] == payload["_id"])
        state['WebinarList'].splice(index, 1)
    },
    SetWebinarRegisterList(state, payload) {

        state.WebinarRegistrations = payload

    },
    SetIndividualWebinarRegister(state, payload) {

        state.WebinarRegistrations.push(payload)

    },
    UpdateIndividualWebinarRegister(state, payload) {

        let index = state['WebinarRegistrations'].findIndex(x => x["_id"] == payload["_id"])
        state['WebinarRegistrations'].splice(index, 1, payload)

    },
    DeleteIndividualWebinarRegister(state, payload) {

        let index = state['WebinarRegistrations'].findIndex(x => x["_id"] == payload["_id"])
        state['WebinarRegistrations'].splice(index, 1)
    }
}

const actions = {

}

const getters = {

    GetWebinarList(state) {

        return state.WebinarList
    },
    GetWebinarRegisterList(state) {

        return state.WebinarRegistrations
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}